import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
  },
  root: {
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: 'auto',
    width: '90vw', // default width
    [theme.breakpoints.up('sm')]: {
      width: '70vw', // width for screens wider than sm
    },
    [theme.breakpoints.up('md')]: {
      width: '50vw', // width for screens wider than md
    },
  },
  paper: {
    borderRadius: '12px',
    padding: theme.spacing(3.75), // 30px
    width: '90vw',
    [theme.breakpoints.up('sm')]: {
      width: '70vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '50vw',
    },
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  headerText: {
    margin: theme.spacing(1, 0),
    color: '#999',
    fontWeight: '600',
    fontSize: '.9rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  },
  divider: {
    marginBottom: theme.spacing(1),
  },
}));
